import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import { withTranslation } from "react-i18next";

import OrderItem from "../../components/OrderItem";
import { isMobileAndTablet } from "../../helpers/common";
import { addToOrder, cancelSelection, deleteOrderItem } from "../../redux/actions/orderActions";

import "./addItemPage.scss";

const AddItemPage = ({
  selectedItem,
  currentOrderItem,
  menuItemTypes,
  selectedItemSupplements,
  selectedItemInstructions,
  selectedBusinessLunch,
  t,
  addToOrder,
  cancelSelection,
  deleteOrderItem,
  currentLanguageId,
  branchInfo,
}) => {
  const history = useHistory();
  const isMobile = isMobileAndTablet();

  useEffect(() => {
    const el = document.getElementById("scrollable-restaurant-layout");
    el.scrollTop = 0;
  }, [selectedItem, selectedItemSupplements]);

  const onAddToCart = (item) => {
    addToOrder(item);
  };

  const onClose = () => {
    goToMenu();
  };

  const onDelete = (item) => {
    deleteOrderItem(item);
  };

  const goToMenu = () => {
    cancelSelection();
    history.goBack();
  };

  return (
    <div
      className={`add-item-page ${isMobile ? "mobile-page" : "desktop-page"}`}
    >
      <div className="container">
        <OrderItem
          menuItem={selectedItem}
          currentOrderItem={currentOrderItem}
          selectedItemSupplements={selectedItemSupplements}
          itemInstructions={selectedItemInstructions}
          t={t}
          onlyAdditions={false}
          menuItemTypes={menuItemTypes}
          addToCart={onAddToCart}
          close={onClose}
          deleteFromCart={onDelete}
          currentLanguageId={currentLanguageId}
          branchInfo={branchInfo}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    selectedItem,
    clientInfo,
    branchInfo,
    currentDeliveryType,
    menuItemTypes,
    selectedItemSupplements,
    selectedItemInstructions,
    selectedBusinessLunch,
    currentOrderItem,
    currentLanguageId,
  } = state;

  return {
    selectedItem,
    clientInfo,
    branchInfo,
    currentDeliveryType,
    menuItemTypes,
    selectedItemSupplements,
    selectedItemInstructions,
    selectedBusinessLunch,
    currentOrderItem,
    currentLanguageId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addToOrder,
      cancelSelection,
      deleteOrderItem,
    },
    dispatch
  );
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(AddItemPage)
);
